export class ExportComplianceReportRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "ExportComplianceReportRequestFormatEnum",
            "format": ""
        },
        {
            "name": "controlIds",
            "baseName": "controlIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "failingGroupBy",
            "baseName": "failingGroupBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "filter",
            "baseName": "filter",
            "type": "Condition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExportComplianceReportRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var ExportComplianceReportRequestFormatEnum;
(function (ExportComplianceReportRequestFormatEnum) {
    ExportComplianceReportRequestFormatEnum["Pdf"] = "pdf";
    ExportComplianceReportRequestFormatEnum["Csv"] = "csv";
    ExportComplianceReportRequestFormatEnum["Zip"] = "zip";
})(ExportComplianceReportRequestFormatEnum || (ExportComplianceReportRequestFormatEnum = {}));
